import React from 'react';
import PropTypes from 'prop-types';
import { getAll, updateOne } from 'api/lookuplistApi';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { COLOR } from 'config';
import Spinner from '../Spinner';
import DanhMucItemPanel from '../2_LookuplistitemPanelStack';

export default class DanhMucPanel extends React.PureComponent {
  state = {
    isLoading: true,
    lookuplistData: [],
  };
  componentWillMount = async () => {
    const res = await getAll();
    this.setState({
      isLoading: false,
    });
    if (res.success) {
      this.setState({
        lookuplistData: res.data.filter((item) => item.LookupListID !== 4), // NOTE  loại bỏ quan huyen
      });
    }
  };
  handleOnChange = async (_id, data) => {
    const res = await updateOne(_id, data);
    if (res.success) {
      this.componentWillMount();
    }
  };

  render() {
    return (
      <div>
        {this.state.isLoading && <Spinner />}
        {!this.state.isLoading && (
          <DataList
            openNewPanel={this.openNewPanel}
            dataList={this.state.lookuplistData}
            onChange={this.handleOnChange}
          />
        )}
      </div>
    );
  }

  openNewPanel = (lookuplist) => {
    const panelNumber = this.props.panelNumber + 1;
    this.props.openPanel({
      component: DanhMucItemPanel,
      props: {
        panelNumber,
        lookuplistId: lookuplist._id,
        LookupListID: lookuplist.LookupListID,
        IsHasExtra: lookuplist.IsHasExtra,
        IsHasChildren: lookuplist.IsHasChildren,
        referenced: lookuplist.referenced,
      },
      title: lookuplist.Name,
    });
  };
}

class DataList extends React.Component {
  static propTypes = {
    dataList: PropTypes.array.isRequired,
    handleEditData: PropTypes.func,
    openNewPanel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  cellEdit = {
    mode: 'dbclick',
  };

  handleTableChange = async (type, { cellEdit, data }) => {
    // const { newValue, dataField } = cellEdit;
    // console.log('---1---', dataField);
    // console.log('---2---', newValue, type, cellEdit);
    const dataTemp = {
      [cellEdit.dataField]: cellEdit.newValue,
    };
    // console.log('---1---', dataTemp);
    if (this.props.onChange) {
      this.props.onChange(cellEdit.rowId, dataTemp);
    }
  };

  render() {
    return (
      <BootstrapTable
        remote={{ cellEdit: true }}
        keyField='_id'
        data={this.props.dataList}
        columns={[
          {
            dataField: 'Name',
            text: 'Tên',
            formatter: (cell, row) => {
              return (
                <a
                  href='_'
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.openNewPanel(row);
                  }}
                  style={{ color: COLOR.SUCCESS }}
                >
                  {cell}
                </a>
              );
            },
          },
        ]}
        onTableChange={this.handleTableChange}
        cellEdit={cellEditFactory(this.cellEdit)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ManagementContainer/DanhMucPanel/1_LookuplistPanelStack/index.js